<template>
  <div class="pd-container">
    <div class="pd-header">
      <div class="title">产品中心</div>
      <div class="en-title">Product Center</div>
    </div>
    <div class="product">
      <div class="product-box" v-for="(item,key) in productInfo" :key="key"
           :style="key==0?bot_min_fast:key==1?bot_min_normal:bot_min_low"
        @click="toDetail(item.id,item.itemIntro)">
        <img :src="$img + item.itemPcCover" class="product-img">
        <div class="product-info">
          <div class="product-name">{{item.itemName}}</div>
          <div class="product-description">
            {{item.itemIntro}}
          </div>
          <div class="get-more-btn">more+</div>
        </div>
      </div>
    </div>
    <div class="more-product-btn" @click="$router.push('/product')">更多产品信息 +</div>
  </div>
</template>

<script>
  export default {
    name: "product",
    data() {
      return {
        bot_min_fast: {
          transition: "transform .5s,bottom .5s",
          bottom: "-425px"
        },
        bot_min_normal: {
          transition: "transform .5s,bottom 1s",
          bottom: "-425px"
        },
        bot_min_low: {
          transition: "transform .5s,bottom 1.5s",
          bottom: "-425px"
        },

        productInfo: [],
      }
    },
    mounted() {
      this.$http.get('/api/item/info/list',{params:{pageSize:3,pageNum:1}}).then((res)=>{
        this.productInfo = res.data.rows
        // console.log('zhe',res.data.rows)
      })
      window.addEventListener('scroll', this.handleScroll, true);
    },
    methods: {
      toDetail(id,itemIntro) {    //跳转详情页
        this.$router.push({
          path: '/productDetail',
          query: {id,itemIntro}
        })
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop >= 600) {
          this.bot_min_fast.bottom = "0px"
          this.bot_min_normal.bottom = "0px"
          this.bot_min_low.bottom = "0px"
        }
      }
    }
  }
</script>

<style scoped>
  .pd-container {
    height: 100vh;
  }

  .pd-header {
    text-align: center;
    margin: 0 auto 60px;
    padding-top: 130px;
    position: relative;
    transition: all 1s;
  }

  .title {
    font-size: 40px;
  }

  .en-title {
    margin-top: 20px;
    font-size: 16px;
    font-style: italic;
    font-weight: bold;
  }

  .product {
    display: flex;
    width: 70%;
    margin: 120px auto 0;
    justify-content: space-around;
  }

  .product-box {
    width: 360px;
    height: 450px;
    border-radius: 40px;
    color: #333;
    font-family: 微軟正黑體;
    /*cursor: pointer;*/
    transition: all .5s;
    position: relative;
    margin: 0 auto;
    box-shadow: 0 5px 20px #e3e3ed;
  }

  .product-box:hover {
    transform: scale(1.05);
  }

  .product-img {
    position: absolute;
    top: -54px;
    right: 0;
  }

  .product-info {
    margin-top: 130px;
    padding: 24px;
  }

  .product-name {
    font-size: 20px;
    font-weight: 600;
    color: #000;
  }

  .product-description {
    font-size: 16px;
    margin-top: 10px;
    color: #768087;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    line-height: 180%;
    letter-spacing: 0.1em;
  }

  .get-more-btn {
    width: 110px;
    height: 36px;
    /*border: 2px solid #333;*/
    border-radius: 2em;
    text-align: center;
    font-size: 20px;
    position: absolute;
    bottom: 36px;
    left: 24px;
    z-index: 99;
    background-color: #6676e7;
    color: #ffffff;
    line-height: 30px;
    transition: all .5s;
  }

  .get-more-btn:hover {
    background-color: #3a4ccc;
    transform: scale(1.06);
  }

  .more-product-btn {
    /*display: inline-block;*/
    width: 200px;
    height: 50px;
    border: 1px solid #000;
    margin: 80px 0 0 -100px;
    line-height: 50px;
    text-align: center;
    transition: all .5s;
    color: #333;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    cursor: pointer;
  }

  .more-product-btn:hover {
    transform: scale(1.06);
  }

  @media (max-width: 1600px) {
    .product {
      width: 92%;
    }
  }

  @media (max-width: 1200px) {
    .product {
      min-width: 1024px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/section/product.vue